import { apiClient, shopMobilePath } from './client';

export interface TodayOrder {
  id: string;
  status: string;
  totalAmount: string;
  remark: string | null;
  customerName: string;
  vehiclePlate: string;
  serviceSummary: string;
}

export interface DashboardData {
  shop: {
    id: string;
    name: string;
    status: string;
    trialState: 'trial' | 'active' | 'readonly' | 'expired';
    trialEndsAt: string;
    remainingTrialDays: number;
  };
  todayOrderCount: number;
  inProgressCount: number;
  readyForPickupCount: number;
  pendingPaymentCount: number;
  customerCount: number;
  pendingPaymentTotal: string;
  todayRevenue: string;
  todayOrders: TodayOrder[];
  unpaidCount: number;
  unpaidTotal: string;
}

export function getDashboard(): Promise<DashboardData> {
  return apiClient.get<DashboardData>(shopMobilePath('/dashboard'));
}
